// extracted by mini-css-extract-plugin
module.exports = {"errorList":"errorList--L7nkT","mainError":"mainError--1nJdL","errorInfoBox":"errorInfoBox--ePU9x","comparison":"comparison--eAv1E"};